<template>

	<form ref="stripe_form" :action="processRoute" method="POST">
		<slot></slot>
	</form>

</template>
<script type="text/javascript">

export default {
	name: "StripeButton",
	components: {
		//VueStripeCheckout
	},
	data() {
		return {
			publicKey: "pk_test_6uXeEGw3rd4jOgrpl5NmjiJF"
		}
	},
	props: [
		"email",
		"name",
		"priceCents",
		"description",
		"label",
		"buttonLabel",
		"processRoute",
		"currency"
	],
	mounted() {
		//set public key to production
		if (window.environment == 'Production')
			this.publicKey = "pk_live_CGSZA0hNKWeUa9cufnHj2yf2"

		let script = document.createElement('script');
		script.src = "https://checkout.stripe.com/checkout.js"
		script.setAttribute('class','stripe-button')
		script.setAttribute('data-key', this.publicKey)
		script.setAttribute('data-amount', this.priceCents)
		script.setAttribute('data-name', this.name)

		if (this.description)
			script.setAttribute('data-description', this.description)

		if (this.buttonText)
			script.setAttribute("data-")

		if (this.buttonLabel)
			script.setAttribute("data-panel-label",this.buttonLabel)
		
		script.setAttribute('data-email', this.email)
		script.setAttribute('data-label', this.label)

		if (this.currency)
			script.setAttribute('data-currency', this.currency)
		else
			script.setAttribute('data-currency', "CAD")

		script.setAttribute('data-locale', "auto")
		script.setAttribute('data-zip-code', "false")

		this.$refs.stripe_form.append(script)
	}
}
</script>